/* SneakerAsk-style product page enhancements - OlyxFashion.
   Adds the pieces SneakerAsk has that this theme's product-template.liquid does
   not render: breadcrumb, share button, image colour swatches and per-size 48H
   badges. Reads data from the OlyxPdpData JSON block printed by
   templates/product.liquid. Every step is defensive - if the markup it expects
   is missing it simply does nothing rather than breaking the buy box. */
(function () {
  'use strict';

  function data() {
    var el = document.getElementById('OlyxPdpData');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var D = data();
  if (!D) return;

  var buyBox = document.querySelector('.OlyxPdp__BuyBox');
  var COLOR_WORDS = ['color', 'colour', 'couleur', 'kleur', 'farbe', 'colore'];

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---------- 1. Breadcrumb ------------------------------------------- */
  function breadcrumb() {
    if (document.querySelector('.OlyxCrumb')) return;
    var host = document.querySelector('.shopify-section[id*="product-template"]');
    if (!host) return;

    var parts = ['<a href="/">Home</a>'];
    if (D.collectionTitle && D.collectionUrl) {
      parts.push('<a href="' + D.collectionUrl + '">' + esc(D.collectionTitle) + '</a>');
    } else if (D.type) {
      parts.push('<a href="/collections/all">' + esc(D.type) + '</a>');
    }
    parts.push('<span>' + esc(D.title) + '</span>');

    var nav = el('nav', 'OlyxCrumb', parts.join('<i aria-hidden="true">|</i>'));
    nav.setAttribute('aria-label', 'Breadcrumb');
    host.insertBefore(nav, host.firstChild);
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  /* ---------- 2. Share button ------------------------------------------ */
  function share() {
    if (!buyBox || document.querySelector('.OlyxShare')) return;
    var row = buyBox.querySelector('.OlyxPdp__RatingRow');
    if (!row) return;

    var btn = el('button', 'OlyxShare',
      '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M10 13V3M10 3 6.5 6.5M10 3l3.5 3.5"/><path d="M4 11v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-5"/></svg>');
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Share this product');
    btn.addEventListener('click', function () {
      var url = location.origin + (D.url || location.pathname);
      if (navigator.share) {
        navigator.share({ title: D.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1600);
        }, function () {});
      }
    });
    row.appendChild(btn);
  }

  /* ---------- 3. Image colour swatches --------------------------------- */
  /* The theme renders colour as another pill group. SneakerAsk shows image
     tiles instead, so map each colour value to the first variant image that
     uses it and repaint the buttons. The click handlers stay untouched. */
  function swatches() {
    if (!D.colorOption || !D.colorImages) return;

    var groups = document.querySelectorAll('.OlyxInline--generic, .OlyxInline--color');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var label = (group.textContent || '').toLowerCase();
      var isColor = false;
      for (var c = 0; c < COLOR_WORDS.length; c++) {
        if (label.indexOf(COLOR_WORDS[c]) === 0 || label.indexOf(COLOR_WORDS[c]) > -1) { isColor = true; break; }
      }
      if (!isColor) continue;

      group.classList.add('OlyxSwatchGroup');
      var btns = group.querySelectorAll('.OlyxSizeBtn');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (b.dataset.olyxSwatch) continue;
        var value = (b.dataset.value || b.textContent || '').trim();
        var img = D.colorImages[value];
        if (!img) continue;
        b.dataset.olyxSwatch = '1';
        b.setAttribute('title', value);
        b.style.backgroundImage = 'url(' + img + ')';
      }
    }
  }

  /* ---------- 4. Per-size 48H badge ------------------------------------ */
  function badges() {
    return; /* 48H badges disabled */
    if (!D.has48h) return;
    var groups = document.querySelectorAll('.OlyxInline--size');
    for (var g = 0; g < groups.length; g++) {
      var btns = groups[g].querySelectorAll('.OlyxSizeBtn');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        if (b.querySelector('.OlyxSizeBadge') || b.disabled) continue;
        var badge = el('span', 'OlyxSizeBadge',
          '<svg viewBox="0 0 10 14" fill="currentColor" aria-hidden="true"><path d="M6 0 0 8h3.2L4 14l6-8H6.8z"/></svg>48H');
        b.appendChild(badge);
      }
    }
  }

  function run() {
    try { breadcrumb(); } catch (e) {}
    try { share(); } catch (e) {}
    try { swatches(); } catch (e) {}
    try { badges(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* the variant picker re-renders on selection, so re-apply after changes */
  document.addEventListener('variant:change', run);
  var mo = new MutationObserver(function () { try { swatches(); badges(); } catch (e) {} });
  var form = document.querySelector('.ProductForm');
  if (form) mo.observe(form, { childList: true, subtree: true });
})();

/* ---- EU / US / UK size toggle (Olyx) ----
   Variant values hold every system ("EU 42 / US M 8.5 / US W 10 / UK 7.5").
   The size-localisation script in theme.liquid shows one system; this bar lets
   the shopper pick it. Choice is stored in localStorage('olyx-size-unit').
   Oct 2026: switching no longer reloads the page. This file runs (defer)
   before theme.liquid and olyx-fixes.js shorten the labels, so it keeps the
   full original text of every size label and can redraw all of them in the
   new system on the spot. On the next page load the theme picks the saved
   system up by itself, exactly as before. */
(function () {
  'use strict';
  var KEY = 'olyx-size-unit';
  var SYSTEMS = ['EU', 'US', 'UK'];
  var root = document.documentElement;
  var RAW_RE = /\b(EU|US|UK)\s/;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1 };
  var raw = new WeakMap();   // text node -> its original full text
  var nodes = [];            // the same text nodes, so they can be walked
  var switched = false;
  var applying = false;

  function current() {
    var c = ' ' + root.className + ' ';
    if (c.indexOf(' olyx-sizes-us ') > -1) return 'US';
    if (c.indexOf(' olyx-sizes-uk ') > -1) return 'UK';
    return 'EU';
  }

  function isRaw(t) { return !!t && t.indexOf('/') > -1 && RAW_RE.test(t); }

  /* same rules as the theme.liquid script */
  function localise(text, sys) {
    text = String(text == null ? '' : text).trim();
    if (!isRaw(text)) return null;
    var re = new RegExp('^' + sys + '\\b', 'i');
    var keep = text.split('/').map(function (p) { return p.trim(); }).filter(function (p) {
      return p && re.test(p);
    }).map(function (p) { return p.replace(/^(EU|US|UK)\s+/i, ''); });
    return keep.length ? keep.join(' / ') : null;
  }

  /* is `shown` the original text or one of its EU / US / UK versions? */
  function isOurs(original, shown) {
    original = String(original).trim();
    shown = String(shown == null ? '' : shown).trim();
    if (shown === original) return true;
    for (var i = 0; i < SYSTEMS.length; i++) {
      if (localise(original, SYSTEMS[i]) === shown) return true;
    }
    return false;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* remember the full text of every size label before it gets shortened */
  function remember(n) {
    var p = n.parentNode;
    if (!p || SKIP[p.nodeName]) return;
    var v = n.nodeValue;
    if (!isRaw(v)) return;
    if (p.nodeName === 'OPTION') { p.setAttribute('data-olyx-raw', v.trim()); return; }
    if (!raw.has(n)) nodes.push(n);
    raw.set(n, v);
  }

  function capture(el) {
    if (!el) return;
    if (el.nodeType === 3) { remember(el); return; }
    if (el.nodeType !== 1 || SKIP[el.nodeName]) return;
    var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) remember(n);
  }

  /* draw every size label in `sys` */
  function apply(sys) {
    applying = true;
    try {
      // plain text: selected size, size popover, card quick-add sizes, cart lines
      var keep = [];
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (!n.isConnected) continue;
        keep.push(n);
        var r = raw.get(n);
        var want = localise(r, sys);
        if (!want) continue;
        var cur = n.nodeValue.trim();
        if (cur !== want && isOurs(r, cur)) n.nodeValue = want;
      }
      nodes = keep;

      // <option> labels (the value / variant id is never touched)
      document.querySelectorAll('option[data-olyx-raw]').forEach(function (o) {
        var r = o.getAttribute('data-olyx-raw');
        var want = localise(r, sys);
        var cur = o.textContent.trim();
        if (want && cur !== want && isOurs(r, cur)) o.textContent = want;
      });

      // product page size buttons (olyx-fixes.js keeps them unique afterwards)
      document.querySelectorAll('.OlyxSizeBtn[data-olyx-val]').forEach(function (b) {
        var r = b.getAttribute('data-olyx-val');
        var want = localise(r, sys);
        if (!want) return;
        var orig = b.getAttribute('data-olyx-orig');
        var cur = b.textContent.trim();
        var stale = orig ? (orig !== want && isOurs(r, orig)) : (cur !== want && isOurs(r, cur));
        if (!stale) return;
        b.textContent = want;
        b.setAttribute('data-olyx-orig', want);
        b.setAttribute('data-olyx-label', want);
        b.setAttribute('data-olyx-html', esc(want));
      });

      // "Size (US):" -> "Size (EU):"
      document.querySelectorAll('.OlyxInline--size .OlyxInline__Label').forEach(function (l) {
        var t = l.textContent;
        var nt = /\((EU|US|UK)\)/.test(t)
          ? t.replace(/\((EU|US|UK)\)/, '(' + sys + ')')
          : t.replace(/\s*:?\s*$/, '') + ' (' + sys + '):';
        if (nt !== t) l.textContent = nt;
      });

      // every toggle on the page shows the active system
      document.querySelectorAll('.Msc__Opt[data-unit]').forEach(function (x) {
        var on = x.getAttribute('data-unit') === sys;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    } finally {
      applying = false;
    }
  }

  function setSystem(u) {
    if (SYSTEMS.indexOf(u) === -1) return;
    try { localStorage.setItem(KEY, u); } catch (err) {}
    switched = true;
    SYSTEMS.forEach(function (s) { root.classList.remove('olyx-sizes-' + s.toLowerCase()); });
    root.classList.add('olyx-sizes-' + u.toLowerCase());
    apply(u);
    try { document.dispatchEvent(new CustomEvent('olyx:size-system', { detail: { system: u } })); } catch (err) {}
  }
  window.OlyxSetSizeSystem = setSystem;

  // 1. snapshot what is on the page now (still the full text at this point)
  capture(document.body);

  // 2. keep remembering whatever renders later (variant changes, popovers,
  //    lazy cards, cart drawer). Mutation callbacks run before the theme's own
  //    timers shorten the text, and before the browser paints, so after a
  //    switch new labels show up in the chosen system straight away.
  new MutationObserver(function (muts) {
    if (applying) return;
    muts.forEach(function (m) {
      if (m.type === 'characterData') { remember(m.target); return; }
      if (m.addedNodes) for (var i = 0; i < m.addedNodes.length; i++) capture(m.addedNodes[i]);
    });
    if (switched) apply(current());
  }).observe(root, { childList: true, subtree: true, characterData: true });

  function build(group) {
    if (group.querySelector('.Msc__Bar')) return;
    var list = group.querySelector('.OlyxInline__SizeList');
    if (!list) return;
    var btn = list.querySelector('.OlyxSizeBtn[data-olyx-val]');
    if (!btn) return;
    var v = btn.getAttribute('data-olyx-val') || '';
    var has = { EU: /\bEU\s/.test(v), US: /\bUS\s/.test(v), UK: /\bUK\s/.test(v) };
    if (!has.EU || !(has.US || has.UK)) return;
    var cur = current();
    var html = '<div class="Msc__Seg" role="group" aria-label="Size system">';
    SYSTEMS.forEach(function (u) {
      if (!has[u]) return;
      var on = u === cur;
      html += '<button type="button" class="Msc__Opt' + (on ? ' is-active' : '') + '" data-unit="' + u + '" aria-pressed="' + on + '">' + u + '</button>';
    });
    var bar = document.createElement('div');
    bar.className = 'Msc__Bar';
    bar.innerHTML = html + '</div>';
    list.parentNode.insertBefore(bar, list);
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-unit]');
      if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var u = b.getAttribute('data-unit');
      if (u === current()) return;
      setSystem(u);
    }, true);
  }
  function run() { document.querySelectorAll('.OlyxInline--size').forEach(function (g) { try { build(g); } catch (e) {} }); }
  if (!document.getElementById('msc-css')) {
    var st = document.createElement('style');
    st.id = 'msc-css';
    st.textContent = '.Msc__Bar{display:flex;flex-wrap:wrap;gap:10px;margin:0 0 12px}' +
      '.Msc__Seg{display:inline-flex;padding:3px;border-radius:999px;background:#f1f1f1;border:1px solid rgba(17,17,17,.06)}' +
      '.Msc__Opt{appearance:none;-webkit-appearance:none;border:0;background:transparent;border-radius:999px;padding:7px 16px;font:inherit;font-size:13px;line-height:1;color:#6b6b6b;cursor:pointer;transition:background .15s,color .15s,box-shadow .15s;-webkit-tap-highlight-color:transparent}' +
      '.Msc__Opt:hover{color:#111}' +
      '.Msc__Opt.is-active{background:#fff;color:#111;font-weight:700;box-shadow:0 1px 3px rgba(17,17,17,.14)}';
    document.head.appendChild(st);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var form = document.querySelector('.ProductForm');
  if (form) new MutationObserver(run).observe(form, { childList: true, subtree: true });
})();

/* size tip (olyx-size-tip.js) and 72h shipping popup (olyx-ship72.js) live in
   their own files next to this one */
(function () {
  try {
    var me = document.currentScript && document.currentScript.src;
    if (!me || document.getElementById('olyx-size-tip-js')) return;
    // bump TIP_VERSION after editing either file, or browsers keep the old copy
    var TIP_VERSION = '7';
    var q = (me.indexOf('?') > -1 ? '&' : '?') + 'tip=' + TIP_VERSION;
    [['olyx-size-tip-js', 'olyx-size-tip.js'], ['olyx-ship72-js', 'olyx-ship72.js']].forEach(function (f) {
      var s = document.createElement('script');
      s.id = f[0];
      s.src = me.replace('olyx-pdp.js', f[1]) + q;
      document.head.appendChild(s);
    });
  } catch (e) {}
})();